<app-site-header *ngIf="showHeaderAndFooter && headerService.showHeader" class="d-print-none"></app-site-header>

<router-outlet></router-outlet>

<app-whatsapp-button></app-whatsapp-button>

<app-site-footer *ngIf="showHeaderAndFooter && footerService.showFooter" class="d-print-none"></app-site-footer>

<!-- <app-faqbot class="d-print-none"></app-faqbot> -->

<app-modal-agenda></app-modal-agenda>
<app-modal-alert></app-modal-alert>
<app-modal-confirm></app-modal-confirm>
<app-modal-error></app-modal-error>

<app-loading [visible]="loading"></app-loading>

<app-debug></app-debug>
